import { useTranslation } from 'react-i18next';
import type { PageType } from 'types';
import type { HotDealsModule } from 'types/capi/modules';

import CarouselScroller from '~/components/CarouselScroller';
import ProductCard from '~/components/ProductCard';
import Tracked from '~/components/Tracked';

const MODULE_TYPE = 'homepage-hot-deals';

type Props = {
  items: HotDealsModule['items'];
  modulePosition?: number;
  pageType: PageType;
};

function ProductsCarousel({ items, modulePosition, pageType }: Props) {
  return (
    <CarouselScroller slidesClassName="gap-2 md:gap-6">
      {items.map((product, productIndex) => (
        <ProductCard.Internal
          key={`product-${productIndex}`}
          product={product}
          padImage
          className="w-[42vw] flex-none md:w-[264px]"
          allowNotifications
          imageLoading="eager"
          cardSize="small"
          showNotificationCount={true}
          modulePosition={modulePosition}
          moduleType={MODULE_TYPE}
          position={productIndex + 1}
          pageType={pageType}
          pagePosition="Homepage Hot Deals"
          overrideInteractionPagePosition={true}
        />
      ))}
    </CarouselScroller>
  );
}

function ViewMoreButton() {
  const { t } = useTranslation('common');

  return (
    <div className="w-36">
      <Tracked.InternalLink
        variant="transparent-black-border"
        className="flex items-center justify-center"
        pagePosition="Homepage Hot Deals"
        name="VIEW_MORE"
        to={`release-dates/?sort=SALE`}
      >
        {t('viewMore')}
      </Tracked.InternalLink>
    </div>
  );
}

export default function HotDeals({ items, modulePosition, pageType }: Props) {
  const { t } = useTranslation('home');

  return (
    <div className="w-full">
      <div className="content-width flex flex-col items-center justify-center gap-6 py-10 md:gap-8 md:py-20">
        <div className="flex flex-col gap-6 self-stretch py-0 md:gap-10">
          <div className="flex flex-col gap-2">
            <h2 className="text-title-xl flex flex-col justify-start gap-2 text-left">
              {t('hotDeals')}
            </h2>
            <div className="text-base md:text-lg">
              {t('hotDealsDescription')}
            </div>
          </div>
          <ProductsCarousel
            items={items}
            modulePosition={modulePosition}
            pageType={pageType}
          />
        </div>
        <ViewMoreButton />
      </div>
    </div>
  );
}
